import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Chrono } from "react-chrono";
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import { proposalService, qprService } from '../../../Services';
import { useDispatch, useSelector } from 'react-redux';
import { proposalActions, qprActions } from '../../../Actions';
import {formatDate} from '../../../Helpers';
import Show from './Show';
import DeliverableForm from './Form/DeliverableForm';

const Lsit = () => {
  const auth = useSelector((state) => state.auth);
  const proposal = useSelector((state) => state.proposal);
  const qpr = useSelector((state) => state.qpr);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [view_qpr, setViewQpr] = useState([]);
  const [log, setLog] = useState([]);
  const [te, setTE] = useState([]);
  const [isOpenDeliverableModal, setIsOpenDeliverableModal] = useState(false);

  let qh1 = "First Quarterly Progress Report";
  let qh2 = "Second Quarterly Progress Report";
  let qh3 = "Third Quarterly Progress Report";

  useEffect(() => {
    proposalService.list().then(res => {
      if(res.status == 401) {
        navigate("/logout");
      }
      let proposal = res.data.proposals[0] ?? [];
      localStorage.setItem("proposal", JSON.stringify(proposal));
      dispatch(proposalActions.proposal(proposal));
    });   
  }, []);

  useEffect(() => {
    qprService.list(proposal.id).then(res => {
      return res.data.list;
      
    }).then(qpr => {
      qpr.map((val, key) => {
        qprService.log(val.id).then(res => {
          qpr[key].log = res.data.log;
          localStorage.setItem("qpr", JSON.stringify(qpr));
        });
        qprService.te(val.id).then(res => {
          qpr[key].te = res.data.te;
          localStorage.setItem("qpr", JSON.stringify(qpr));
        });
      });
      localStorage.setItem("qpr", JSON.stringify(qpr));
      dispatch(qprActions.qpr(qpr));
    });    
  }, [proposal]);

  const [submitted, setSubmitted] = useState(false);
  const [file, setFile] = useState('');
  const [fileSize, setFileSize] = useState(true);
  const [selected_file, setSelectedFile] = useState(null);

  const handleChange = (e) => {
    setFile(e.target.files);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setFileSize(true);
    setSubmitted(true);
    submitForm(e);
  }

  const deleteUC = (qpr_id, uc_no) => {
    qprService.utilizationCertificateDelete(qpr_id).then(res => {
      qpr[uc_no].utilization_certificate = res.data.utilization_certificate;
      localStorage.setItem("qpr", JSON.stringify(qpr));
      dispatch(qprActions.qpr(qpr));
      setSubmitted(false);
    });
  } 
  
  const submitForm = (e) => {
    const formData = new FormData();
    const qpr_id = e.target.qpr_id.value;
    const uc_no = e.target.uc_no.value;
    formData.append('submit_status', 1);
    formData.append('uc_no', uc_no);
    if (file[0].size > 10240000){
      setFileSize(false);
      setSubmitted(false);
      return;
    }
    formData.append('utilization_certificate', file[0]);
    qprService.utilizationCertificateSave(formData, qpr_id).then(res => {
      qpr[uc_no].utilization_certificate = res.data.utilization_certificate;
      localStorage.setItem("qpr", JSON.stringify(qpr));
      dispatch(qprActions.qpr(qpr));
      setSubmitted(false);
    });
  }
  
  const QprList = (prop) => {
    let qpr = prop.qpr;
    let qh = prop.qh;
    let content = "";
    if(qpr) {
      if(qpr.user_status == 1) {
        content = <Link to={'#'}  data-toggle="modal" data-target="#QPRModal" onClick={() => setViewQpr({id: qpr.id, qh: qh})} className="badge badge-success p-2">View QPR</Link>
        // content = <Link to={'/user/qpr/show'} state={{ qpr_id: qpr.id, qh: qh }} className="badge badge-success p-2">View QPR</Link>
      } else {
        content = <Link to={'/user/qpr/add/basic-information'} state={{ qpr_id: qpr.id, qh: qh }} className={(qpr.user_status==0? "badge-danger": "badge-success") + " badge p-2"}>Submit QPR</Link>
      }
    } else {
      content = <span className="badge badge-secondary p-2">Inactive</span>;
    }

    return content;
  }

  const log_items = []; 
  if(log) {
    log.map(val => {
      log_items.push({
        title: formatDate(val.created_at),
        cardTitle: val.user_type == "Fellow"? auth.user.firstname+" "+auth.user.lastname: val.user_type,
        cardSubtitle: val.action,
        cardDetailedText: val.comment,
      });
    });
  }
  const QprModal = () => {
    return (
      <>
        <div className={"modal fade"} id="QPRModal">
          <div className="modal-dialog modal-dialog-scrollable modal-xl">
            <div className="modal-content">
            
              <div className="modal-header">
                <h4 className="modal-title">{view_qpr.qh}</h4>
                <button type="button" className="close" data-dismiss="modal">×</button>
              </div>
              
              <div className="modal-body">
                <div>
                  <Show qpr_id={view_qpr.id} />
                </div>
              </div>
              
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
              </div>
              
            </div>
          </div>
        </div>
      </>
    )
  }
  const LogModal = () => {
    return (
      <>
        <div className={"modal fade"} id="LogModal">
          <div className="modal-dialog modal-dialog-scrollable modal-lg">
            <div className="modal-content">
            
              <div className="modal-header">
                <h4 className="modal-title">Track QPR</h4>
                <button type="button" className="close" data-dismiss="modal">×</button>
              </div>
              
              <div className="modal-body">
                <div>
                  <Chrono items={log_items} mode="VERTICAL" />
                </div>
              </div>
              
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
              </div>
              
            </div>
          </div>
        </div>
      </>
    )
  }
  const TEModal = () => {
    return (
      <>
        <div className={"modal fade"} id="TEModal">
          <div className="modal-dialog modal-dialog-scrollable modal-xl">
            <div className="modal-content">
            
              <div className="modal-header">
                <h4 className="modal-title">Technical Evaluation</h4>
                <button type="button" className="close" data-dismiss="modal">×</button>
              </div>
              
              <div className="modal-body">
                <div>
                  <table className='table'>
                    <thead>
                      <tr>
                        <th></th>
                        {
                          te && te.map(val => <th>{val.title+" "+val.full_name}</th>)
                        }
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><h6>Progress of work as per agreed timelines</h6></td>
                        {
                          te && te.map(val => <td>{val.work_progress ?? "Pending"}</td>)
                        }
                      </tr>
                      <tr>
                        <td><h6>Relevance to the research objective</h6></td>
                        {
                          te && te.map(val => <td>{val.relevance ?? "Pending"}</td>)
                        }
                      </tr>
                      <tr>
                        <td><h6>Comprehensiveness</h6></td>
                        {
                          te && te.map(val => <td>{val.comprehensiveness ?? "Pending"}</td>)
                        }
                      </tr>
                      <tr>
                        <td><h6>Clarity of communication</h6></td>
                        {
                          te && te.map(val => <td>{val.communication ?? "Pending"}</td>)
                        }
                      </tr>
                      <tr>
                        <td><h6>Is the project expected to be completed within the stipulated time?</h6></td>
                        {
                          te && te.map(val => <td>{val.project_completion ?? "Pending"}</td>)
                        }
                      </tr>
                      <tr>
                        <td><h6>Is the project on track to meet its original objective?</h6></td>
                        {
                          te && te.map(val => <td>{val.project_track ?? "Pending"}</td>)
                        }
                      </tr>
                      <tr>
                        <td><h6>Any additional suggestions</h6></td>
                        {
                          te && te.map(val => <td>{val.suggestion ?? "Pending"}</td>)
                        }
                      </tr>
                      <tr>
                        <td><h6>Is the progress satisfactory/ unsatisfactory?</h6></td>
                        {
                          te && te.map(val => <td>{val.progress_status ?? "Pending"}</td>)
                        }
                      </tr>
                      <tr>
                        <td><h6>Recommendations</h6></td>
                        {
                          te && te.map(val => <td>{val.recommendation ?? "Pending"}</td>)
                        }
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
              </div>
              
            </div>
          </div>
        </div>
      </>
    )
  }

  const UCModal = () => {
    return (
      <>
        <div className={"modal fade"} id="ucModal">
          <div className="modal-dialog modal-dialog-scrollable modal-lg">
            <div className="modal-content">
            
              <div className="modal-header">
                {/* <h1 className="modal-title">Modal Heading</h1> */}
                <button type="button" className="close" data-dismiss="modal">×</button>
              </div>
              
              <div className="modal-body">
                {selected_file && 
                <DocViewer
                  pluginRenderers={DocViewerRenderers} 
                  documents={
                    [
                      { uri: process.env.REACT_APP_PUBLIC_URL+"/uploads"+selected_file },
                      // { uri: require(selected_file) }, // Local File
                    ]
                  } 
                />
                }
              </div>
              
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
              </div>
              
            </div>
          </div>
        </div>
      </>
    )
  }

  const DeliverableModal = () => {
    return (
      <>
        <div className={"modal fade"} id="deliverableModal">
          <div className="modal-dialog modal-dialog-scrollable modal-xl">
            <div className="modal-content">
            
              <div className="modal-header">
                <h4 className="modal-title">Deliverables (Draft and Final)</h4>
                <button type="button" className="close" data-dismiss="modal" onClick={() => setIsOpenDeliverableModal(false)}>×</button>
              </div>
              
              <div className="modal-body">
                <div>
                  <DeliverableForm appid={proposal.id} />
                </div>
              </div>
              
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={() => setIsOpenDeliverableModal(false)}>Close</button>
              </div>
              
            </div>
          </div>
        </div>
      </>
    )
  }
  
  return (
    <>
      <div className="card border-success">
        <div className="card-header bg-light p-2 border-success" style={{"borderTop": "3px solid"}}><h6>Application ID: {proposal.registerNumber} - Quarterly Progress Reports</h6></div>
        <div className="card-body">
          <table className='table'>
            <tbody>
              {qpr[0] && 
              <tr>
                <td width={"50%"}>
                  {qh1}<br/>
                  <a href='../images/fellows/2022-2023/Q1_QPR_PPT slides.pptx'>Download Presentation Template</a>
                </td>
                <td className='text-center'>
                  <QprList qpr={qpr[0]} qh={qh1} />
                </td>
                <td className='text-center'>
                  {qpr[0] && qpr[0].admin_status == 1 && 
                      <Link to={'#'} className="badge-warning badge p-2 text-white" data-toggle="modal" data-target="#TEModal" onClick={() => setTE(qpr[0].te)}>Technical Evaluation</Link>
                  }
                </td>
                <td className='text-center'>
                  {qpr[0] && qpr[0].admin_status == 1 && 
                    <a href={process.env.REACT_APP_PUBLIC_URL+'/admin/preview/pr/qpr_download.php?qpr_id='+qpr[0].id} target={'_blank'} className="badge-primary badge p-2 text-white">Download</a>
                  }
                </td>
                <td className='text-center'>
                  {qpr[0] && (qpr[0].user_status == 1 || qpr[0].mentor_status != null) && 
                    <Link to={'#'} className={(qpr[0].user_status==0? "badge-danger": "badge-info") + " badge p-2"}  data-toggle="modal" data-target="#LogModal" onClick={() => setLog(qpr[0].log)}>Track QPR</Link>
                  }
                </td>
              </tr>
              }
              {qpr[0] && qpr[0].admin_status == 1 && 
              <tr>
                <td>First Utilisation certificate</td>
                <td colSpan={4}>
                  {qpr[0].utilization_certificate == null ?
                    <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                        <p>Maximum file size: 10MB</p>
                        <input type="hidden" name="qpr_id" value={qpr[0].id} />
                        <input type="hidden" name="uc_no" value="0" />
                        <input type="file" className='custom-file-input1' id="customFile" name='utilization_certificate' onChange={handleChange} />
                        {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                        {!fileSize && <p style={{color:'red'}}>File size should not be greater than 10MB!</p>}
                        <button type="submit" className="btn btn-info">
                        {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Upload</span>}
                        </button>
                      <hr/>
                      
                    </form>
                    :
                    <div className='col-md-3 mt-2'>
                      <div className="media1 border p-2" >
                        <div className="clearfix">
                          <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} data-toggle="modal" data-target="#ucModal" onClick={() => setSelectedFile(qpr[0].utilization_certificate)} />
                          <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteUC(qpr[0].id, 0)} className="float-right" style={{height: "10px", cursor: "pointer"}} />
                        </div>
                      </div>
                    </div>
                  }
                </td>
              </tr>
              }

              {qpr[1] && 
              <tr>
                <td>
                  {qh2}<br/>
                  <a href='../images/fellows/2022-2023/Q2_QPR_PPT slides.pptx'>Download Presentation Template</a>
                </td>
                <td className='text-center'>
                  <QprList qpr={qpr[1]} qh={qh2} />
                </td>
                <td className='text-center'>
                  {qpr[1] && qpr[1].admin_status == 1 && 
                      <Link to={'#'} className="badge-warning badge p-2 text-white" data-toggle="modal" data-target="#TEModal" onClick={() => setTE(qpr[1].te)}>Technical Evaluation</Link>
                  }
                </td>
                <td className='text-center'>
                  {qpr[1] && qpr[1].admin_status == 1 && 
                    <a href={process.env.REACT_APP_PUBLIC_URL+'/admin/preview/pr/qpr_download.php?qpr_id='+qpr[1].id} target={'_blank'} className="badge-primary badge p-2 text-white">Download</a>
                  }
                </td>
                <td className='text-center'>
                  {qpr[1] && (qpr[1].user_status == 1 || qpr[1].mentor_status != null) && 
                    <Link to={'#'} className={(qpr[1].user_status==0? "badge-danger": "badge-info") + " badge p-2"}  data-toggle="modal" data-target="#LogModal" onClick={() => setLog(qpr[1].log)}>Track QPR</Link>
                  }
                </td>
              </tr>
              }

              {qpr[1] && qpr[1].admin_status == 1 && 
              <tr>
                <td>First Utilisation certificate</td>
                <td colSpan={4}>
                  {qpr[1].utilization_certificate == null ?
                    <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                        <p>Maximum file size: 10MB</p>
                        <input type="hidden" name="qpr_id" value={qpr[1].id} />
                        <input type="hidden" name="uc_no" value="1" />
                        <input type="file" className='custom-file-input1' id="customFile" name='utilization_certificate' onChange={handleChange} />
                        {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                        {!fileSize && <p style={{color:'red'}}>File size should not be greater than 10MB!</p>}
                        <button type="submit" className="btn btn-info">
                        {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Upload</span>}
                        </button>
                      <hr/>
                      
                    </form>
                    :
                    <div className='col-md-3 mt-2'>
                      <div className="media1 border p-2" >
                        <div className="clearfix">
                          <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} data-toggle="modal" data-target="#ucModal" onClick={() => setSelectedFile(qpr[1].utilization_certificate)} />
                          <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteUC(qpr[1].id, 1)} className="float-right" style={{height: "10px", cursor: "pointer"}} />
                        </div>
                      </div>
                    </div>
                  }
                </td>
              </tr>
              }
              
              {qpr[2] && 
              <tr>
                <td>
                  {qh3}<br/><a href='../images/fellows/2022-2023/Q3_QPR_PPT slides.pptx'>Download Presentation Template</a>
                </td>
                <td className='text-center'>
                  <QprList qpr={qpr[2]} qh={qh3} />
                </td>
                <td className='text-center'>
                  {qpr[2] && qpr[2].admin_status == 1 && 
                      <Link to={'#'} className="badge-warning badge p-2 text-white" data-toggle="modal" data-target="#TEModal" onClick={() => setTE(qpr[2].te)}>Technical Evaluation</Link>
                  }
                </td>
                <td className='text-center'>
                  {qpr[2] && qpr[2].admin_status == 1 && 
                    <a href={process.env.REACT_APP_PUBLIC_URL+'/admin/preview/pr/qpr_download.php?qpr_id='+qpr[2].id} target={'_blank'} className="badge-primary badge p-2 text-white">Download</a>
                  }
                </td>
                <td className='text-center'>
                  {qpr[2] && (qpr[2].user_status == 1 || qpr[2].mentor_status != null) && 
                    <Link to={'#'} className={(qpr[2].user_status==0? "badge-danger": "badge-info") + " badge p-2"}  data-toggle="modal" data-target="#LogModal" onClick={() => setLog(qpr[2].log)}>Track QPR</Link>
                  }
                </td>
              </tr>
              }

              {qpr[2] && qpr[2].admin_status == 1 &&
              <>
                <tr>
                  <td>Second Utilisation certificate</td>
                  <td colSpan={4}>
                    {qpr[2].utilization_certificate == null ?
                      <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                          <p>Maximum file size: 10MB</p>
                          <input type="hidden" name="qpr_id" value={qpr[2].id} />
                          <input type="hidden" name="uc_no" value="2" />
                          <input type="file" className='custom-file-input1' id="customFile" name='utilization_certificate' onChange={handleChange} />
                          {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                          {!fileSize && <p style={{color:'red'}}>File size should not be greater than 10MB!</p>}
                          <button type="submit" className="btn btn-info">
                          {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Upload</span>}
                          </button>
                        <hr/>
                        
                      </form>
                      :
                      <div className='col-md-3 mt-2'>
                        <div className="media1 border p-2" >
                          <div className="clearfix">
                            <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} data-toggle="modal" data-target="#ucModal" onClick={() => setSelectedFile(qpr[2].utilization_certificate)} />
                            <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteUC(qpr[2].id, 2)} className="float-right" style={{height: "10px", cursor: "pointer"}} />
                          </div>
                        </div>
                      </div>
                    }
                  </td>
                </tr>

                <tr>
                  <td>Deliverables (Draft and Final)</td>
                  <td className='text-center'>
                      <button data-toggle="modal" data-target="#deliverableModal" className="badge badge-info p-2" onClick={() => setIsOpenDeliverableModal(true)}>Open</button>
                  </td>
                  <td className='text-center'></td>
                  <td className='text-center'></td>
                  <td className='text-center'></td>
                </tr>
              </> 
              }
            </tbody>
          </table>
        </div>
      </div>      
      <QprModal />
      <LogModal />
      <TEModal />
      <UCModal />
      {isOpenDeliverableModal && <DeliverableModal />}
    </>
  );
};

export default Lsit;